import React from 'react';
import './CurrentTime.css';

function CurrentTime() {
  const getFormattedTime = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure minutes are always two digits
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Use 12 for midnight (0) and noon (12)
    return `${formattedHours}:${minutes} ${period}`;
  };

  return (
    <h3 className="time" style={{margin: '24px'}}>{getFormattedTime()}</h3>
  );
}

export default CurrentTime;
